/**
 * actionTypes.js
 * Created by michaelbray on 2/13/18.
 */

// Configuration
export const MAX_SESSION_HOURS = 2;

// Alert Actions
export const ALERTS_FETCHED = 'ALERTS_FETCHED';
export const FETCHING_ALERTS_FAILED = 'FETCHING_ALERTS_FAILED';

// Account-Related Action Types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOCKOUT = 'LOCKOUT';
export const LOGIN_BAD_MAGIC = 'LOGIN_BAD_MAGIC';
export const CSR_LOGIN_SUCCESS = 'CSR_LOGIN_SUCCESS';
export const CSR_CLEAR_SELECTED = 'CSR_CLEAR_SELECTED';

// recaptcha related action types
export const RECAPTCHA_SUCCESS = 'RECAPTCHA_SUCCESS';
export const RECAPTCHA_ERROR = 'RECAPTCHA_ERROR';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const MFA_REQUIRED = 'MFA_REQUIRED';
export const ACCOUNT_SERVICE_STATUS_UPDATED = 'ACCOUNT_SERVICE_STATUS_UPDATED';

// Modal Actions
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
export const SHOW_SIGN_IN_GUEST_MODAL = 'SHOW_SIGN_IN_GUEST_MODAL';
export const HIDE_SIGN_IN_GUEST_MODAL = 'HIDE_SIGN_IN_GUEST_MODAL';
export const SHOW_CREATE_ACCOUNT_MODAL = 'SHOW_CREATE_ACCOUNT_MODAL';
export const HIDE_CREATE_ACCOUNT_MODAL = 'HIDE_CREATE_ACCOUNT_MODAL';
export const SHOW_RESET_MODAL = 'SHOW_RESET_MODAL';
export const HIDE_RESET_MODAL = 'HIDE_RESET_MODAL';

// Cart
export const GET_CART = 'GET_CART';
export const GET_CART_HEADER = 'GET_CART_HEADER';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const ADD_ITEM = 'ADD_ITEM';
export const CART_ERROR = 'CART_ERROR';
export const ADD_ITEM_ERROR = 'ADD_ITEM_ERROR';
export const REMOVE_ALL_ITEMS = 'REMOVE_ALL_ITEMS';
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR';
export const EXTEND_EXPIRATION_ERROR = 'EXTEND_EXPIRATION_ERROR';

// Reservation
export const REMOVE_RESERVATION_ERROR = 'REMOVE_RESERVATION_ERROR';

// Search
export const GET_SEARCH_SUGGESTIONS = "GET_SEARCH_SUGGESTIONS";
export const GET_SEARCH_SUGGESTIONS_ERROR = "GET_SEARCH_SUGGESTIONS_ERROR";
export const GET_SEARCH_ERROR = "GET_SEARCH_ERROR";
export const UPDATE_SEARCH_CRITERIA = "UPDATE_SEARCH_CRITERIA";
export const UPDATE_SEARCH_CRITERIAS = "UPDATE_SEARCH_CRITERIAS";
export const ADD_SEARCH_FILTER = "ADD_SEARCH_FILTER";
export const SET_SEARCH_FILTER = "SET_SEARCH_FILTER";
export const REMOVE_SEARCH_FILTER = "REMOVE_SEARCH_FILTER";
export const RESET_SEARCH_FILTERS = "RESET_SEARCH_FILTERS";
export const RESET_SEARCH_FILTERS_CAMPSITES = "RESET_SEARCH_FILTERS_CAMPSITES";
export const HIGHLIGHT_SEARCH_RESULT_ITEM = "HIGHLIGHT_SEARCH_RESULT_ITEM";
export const UPDATE_CHECKIN_DATE = "UPDATE_CHECKIN_DATE";
export const UPDATE_CHECKOUT_DATE = "UPDATE_CHECKOUT_DATE";

// Navigation Bar
export const SHOW_SEARCH_INPUT = "SHOW_SEARCH_INPUT";
export const HIDE_SEARCH_INPUT = "HIDE_SEARCH_INPUT";

// Notifications
export const RESET_ERROR = "RESET_ERROR";
export const DISMISS_ERROR_NOTIFICATION = "DISMISS_ERROR_NOTIFICATION";
export const DISMISS_SUCCESS_NOTIFICATION = "DISMISS_SUCCESS_NOTIFICATION";
export const DISMISS_WARNING_NOTIFICATION = "DISMISS_WARNING_NOTIFICATION";
export const DISMISS_ALL_NOTIFICATIONS = "DISMISS_ALL_NOTIFICATIONS";
export const DISMISS_INFO_NOTIFICATION = "DISMISS_INFO_NOTIFICATION";
export const SET_ERROR_NOTIFICATION = "SET_ERROR_NOTIFICATION";
export const SET_SUCCESS_NOTIFICATION = "SET_SUCCESS_NOTIFICATION";
export const SET_WARNING_NOTIFICATION = "SET_WARNING_NOTIFICATION";
export const SET_INFO_NOTIFICATION = "SET_INFO_NOTIFICATION";

// Recommendations
export const RECOMMENDATION_FAILED = "RECOMMENDATION_FAILED";
export const RECOMMENDATION_RESULTS = "RECOMMENDATION_RESULTS";

//Slugs
export const INVENTORY_FETCH_SLUGS_START = "INVENTORY_FETCH_SLUGS_START";
export const INVENTORY_FETCH_SLUGS_SUCCESS = "INVENTORY_FETCH_SLUGS_SUCCESS";
export const INVENTORY_FETCH_SLUGS_FAILURE = "INVENTORY_FETCH_SLUGS_FAILURE";
